import React from 'react';
import OrderReturnDetail from '../OrderReturnDetail';
import OrderReturnDetailNavbar from '../OrderReturnDetailNavbar';
import { ORDER_RETURN_STATUS } from '../../../../../constants/service/app/orderConstants';
import './OrderReturnDetailWrap.scss';

const OrderReturnDetailWrap = (props) => {
  const { form, onSubmit, onChangeRefundActualAmount, orderReturnDetail, setData } = props;

  return (
    <div className="order-return-detail-wrap">
      {
        /**
         *  return status 가 반품 승인일때만
         *  반품 완료 버튼이 있는 Navbar 를
         */
        orderReturnDetail.orderReturnStatus === ORDER_RETURN_STATUS.RETURN_DONE && (
          <OrderReturnDetailNavbar onSubmit={onSubmit} />
        )
      }

      {/*  주문 반품 상세  */}
      <OrderReturnDetail
        form={form}
        onChangeRefundActualAmount={onChangeRefundActualAmount}
        orderReturnDetail={orderReturnDetail}
        setData={setData}
      />
    </div>
  );
};

export default OrderReturnDetailWrap;
